<i18n>
  {
    "en": {
      "margin": "Total margin"
    },
    "es": {
      "margin": "Margen total"
    }
  }
</i18n>

<script>
import Component from 'vue-class-component';
import { MapActions } from '@core/helpers/decorators';
import KpiComponent from './KpiComponent.vue';
import * as KPITypes from '../constants';

@Component
@MapActions(['calculatePosMarginKPI'])
export default class MarginKpi extends KpiComponent {
  icon = 'mdi-margin'

  iconSize = 25

  kpiType = KPITypes.MARGIN

  isCurrencyUnit = true

  get title() {
    return this.$t('margin');
  }

  async calculate() {
    await this.calculatePosMarginKPI({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    this.loadKPIModel();
  }
}
</script>
